define(
    'Item.KeyMapping.Site',
    [
        'Item.KeyMapping'
    ,   'SC.Configuration'
    ,   'Profile.Model'
    ,   'underscore'
	,	'Utils'
	,	'UrlHelper'
    ],
    function extendKeyMapping(
        ItemsKeyMapping
    ,   Configuration
    ,   ProfileModel
	,	_
	,	Utils
    ) {
        'use strict';

        ItemsKeyMapping.getKeyMapping = _.wrap(ItemsKeyMapping.getKeyMapping, function wrapKeyMapping(fn) {
            var originalItemsKeyMapping = fn.apply(this, _.toArray(arguments).slice(1));
            var newKeyMapping = _.extend(originalItemsKeyMapping, {
                _thumbnail: function (item)
    			{
    				if(item.get('custitemitemimageurl1')){
    					return {
    						url: item.get('custitemitemimageurl1')
    					,	altimagetext: item.get('_name')
    					};
    				}
    				// still nothing? image the not available
    				return {
    					url:  Utils.getThemeAbsoluteUrlOfNonManagedResources('img/no_image_available.jpeg', Configuration.get('imageNotAvailable'))
    				,	altimagetext: item.get('_name')
    				};
                },
                
                _comparePriceAgainst: function (item){
                                var prices = item.get('_priceDetails'),
                    strikePrice = item.get('pricelevel1');

                    if (!strikePrice && prices){
                                                if (prices.priceschedule){
                                                                strikePrice = prices.priceschedule[0].price;
                                                } else {
                                                                strikePrice = prices.onlinecustomerprice;
                                                }
                                }
                    return strikePrice;
                },

               _comparePriceAgainstFormated: function (item){
                    var prices = item.get('_priceDetails'),
                    strikePriceFormatted = item.get('pricelevel1_formatted');

                    if (!strikePriceFormatted && prices){
                                                if (prices.priceschedule){
                                                                strikePriceFormatted = prices.priceschedule[0].price_formatted;
                                                } else {
                                                                strikePriceFormatted = prices.onlinecustomerprice_formatted;
                                                }
                                }
                                return strikePriceFormatted;
                }



            });

            return newKeyMapping;
        });
    });

